import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class NotificationsApi extends ApiModule {
	constructor() {
		super(ModulesMap.NOTIFICATIONS, {
			entity: 'notifications',
		})
	}

	/**
	 * Счётчик непрочитанных — отдельный эндпоинт (.../notifications/unread_count/), провайдер его не покрывает.
	 */
	getNotificationsUnreadCount(options = {}) {
		const config = {
			url: this.generateUrl(false, { suffix: 'unread_count' }),
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	/**
	 * Настройки уведомлений — отдельный вложенный ресурс (.../notifications/settings/...), провайдер его не покрывает.
	 */
	getNotificationsSettings(options = {}) {
		const config = {
			url: this.generateUrl(false, { suffix: 'settings' }),
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	/**
	 * .../notifications/settings/:entityId/ — статический сегмент "settings" стоит ПЕРЕД id,
	 * стандартный generateUrl(true, {suffix}) так не умеет (suffix всегда после entityId).
	 */
	patchNotificationsSettings(options = {}) {
		const config = {
			url: `${this.generateUrl(false)}settings/:entityId/`,
			requestOptions: {
				method: 'PATCH',
			},
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	/**
	 * Массовые действия "отметить прочитанным" — общий эндпоинт (.../notifications/mark_read_status/)
	 * для двух разных операций (пометить все / пометить выбранные), провайдер его не покрывает.
	 */
	patchNotificationsMarkAllRead(options = {}) {
		const config = {
			url: this.generateUrl(false, { suffix: 'mark_read_status' }),
			requestOptions: {
				method: 'PATCH',
			},
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	patchNotificationsMarkReadStatus(options = {}) {
		const config = {
			url: this.generateUrl(false, { suffix: 'mark_read_status' }),
			requestOptions: {
				method: 'PATCH',
			},
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}
}
